<template>
  <div>
    <slot name="trigger" :open="open">
      <el-button @click.stop="open" :disabled="disabled" v-bind="{ type: 'primary', ...triggerButtonProps }">{{ triggerText }}</el-button>
    </slot>

    <el-dialog
      :fullscreen="fullScreen"
      :custom-class="customClass"
      :visible.sync="dialogVisible"
      :title="title"
      append-to-body
      :key="contentKey"
    >
      <slot></slot>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class DialogContent extends Vue {
  @Prop({ type: String, default: '' }) title;
  @Prop({ type: String, default: '查看详情' }) triggerText;
  @Prop({ type: Boolean, default: false }) fullScreen;
  @Prop({ type: Boolean, default: false }) disabled;
  @Prop({ type: Object, default: () => ({}) }) triggerButtonProps;
  @Prop(Boolean) reRenderWhenOpen;

  dialogVisible = false;

  contentKey = 0;

  get customClass() {
    if (this.fullScreen) {
      return 'dialog-full-screen';
    }
    return undefined;
  }

  async open() {
    if (this.reRenderWhenOpen) {
      this.contentKey += 1;
      await this.$nextTick();
    }
    this.dialogVisible = true;
  }
}
</script>
